class CommentsData {

    constructor() {
        this._commentsList = [];
    }

    getCommentsList() {
        return this._commentsList;
    }

    getComment(commentId) {
        return _.find(this._commentsList, function(comment) { return comment.comment_id === commentId });
    }

    setComment(commentData) {
        const index = _.findIndex(this._commentsList, {comment_id: commentData.comment_id});
        this._commentsList[index] = commentData;
    }

    setCommentsList(commentsList) {
        this._commentsList = commentsList;
    }

}